var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0791 3.08752C12.307 3.31533 12.307 3.68467 12.0791 3.91248L5.66248 10.3291C5.43467 10.557 5.06533 10.557 4.83752 10.3291L1.92085 7.41248C1.69305 7.18467 1.69305 6.81533 1.92085 6.58752C2.14866 6.35972 2.51801 6.35972 2.74581 6.58752L5.25 9.09171L11.2542 3.08752C11.482 2.85972 11.8513 2.85972 12.0791 3.08752Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2b0b9f409e52e2337a396b0b213f7de2.svg";
export { ForwardRef as ReactComponent };